// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body {
    width: 8.5in;
    height: 11in;
  }

  .TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE {
    border: none;
    box-shadow: none;
  }
}

@page def {
  size: 8.5in 11in;
  margin: 0;
  padding: 0;
}

.TrusteeReceipt__trusteeReceipt____8_0X {
  display: inline-block;
}

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE {
  display: inline-block;
  margin: auto;
  padding: 0;
  width: auto;
}

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx {
    page: def;
    display: inline-block;
    position: relative;
    width: 8.5in;
    height: 11in;
  }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx p {
      margin-top: 20px;
      margin-bottom: 20px;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__content___kQ2lw {
      padding: 0 0.79375cm;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__logo___U7W4p {
      display: block;
      width: 390px;
      margin: 2cm auto;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__header___GY8kI {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__title___J3kk2 {
      margin: 0 auto 20px;
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 115%;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__textAlignEnd___pfPta {
      text-align: right;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__signature___J6tMK {
      width: 250px;
      margin-left: auto;
      margin-top: 75px;
      padding-top: 15px;
      border-top: 1px solid black;
      position: relative;
    }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__signature___J6tMK img {
        position: absolute;
        bottom: 70%;
        width: 50%;
        left: 25%;
      }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__fromAddress___U1g33 {
    position: absolute;
    left: 0.79375cm;
    bottom: 4.47375cm;
    margin: 0;
  }

.TrusteeReceipt__trusteeReceipt____8_0X .TrusteeReceipt__card___yALmE .TrusteeReceipt__page___oKoAx .TrusteeReceipt__toAddress___j6Bk4 {
    position: absolute;
    left: 1.74625cm;
    bottom: 0.34625cm;
    margin: 0;
  }
`, "",{"version":3,"sources":["webpack://./universal/components/TrusteeReceipt/TrusteeReceipt.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,WAAW;AAwEb;;AAtEE;IACE,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EAkDd;;AAhDE;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;AAEA;MACE,oBAAoB;IACtB;;AAEA;MACE,cAAc;MACd,YAAY;MACZ,gBAAgB;IAClB;;AAEA;MACE,aAAa;MACb,yBAAyB;MACzB,mBAAmB;IACrB;;AAEA;MACE,mBAAmB;MACnB,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;IACjB;;AAEA;MACE,iBAAe;IACjB;;AAEA;MACE,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,2BAA2B;MAC3B,kBAAkB;IAQpB;;AANE;QACE,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,SAAS;MACX;;AAIJ;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;AAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX","sourcesContent":["@media print {\n  body {\n    width: 8.5in;\n    height: 11in;\n  }\n\n  .trusteeReceipt .card {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@page def {\n  size: 8.5in 11in;\n  margin: 0;\n  padding: 0;\n}\n\n.trusteeReceipt {\n  display: inline-block;\n}\n\n.trusteeReceipt .card {\n  display: inline-block;\n  margin: auto;\n  padding: 0;\n  width: auto;\n\n  .page {\n    page: def;\n    display: inline-block;\n    position: relative;\n    width: 8.5in;\n    height: 11in;\n\n    p {\n      margin-top: 20px;\n      margin-bottom: 20px;\n    }\n\n    .content {\n      padding: 0 0.79375cm;\n    }\n\n    .logo {\n      display: block;\n      width: 390px;\n      margin: 2cm auto;\n    }\n\n    .header {\n      display: flex;\n      justify-content: flex-end;\n      margin-bottom: 20px;\n    }\n\n    .title {\n      margin: 0 auto 20px;\n      text-align: center;\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 115%;\n    }\n\n    .textAlignEnd {\n      text-align: end;\n    }\n\n    .signature {\n      width: 250px;\n      margin-left: auto;\n      margin-top: 75px;\n      padding-top: 15px;\n      border-top: 1px solid black;\n      position: relative;\n\n      img {\n        position: absolute;\n        bottom: 70%;\n        width: 50%;\n        left: 25%;\n      }\n    }\n  }\n\n  .page .fromAddress {\n    position: absolute;\n    left: 0.79375cm;\n    bottom: 4.47375cm;\n    margin: 0;\n  }\n\n  .page .toAddress {\n    position: absolute;\n    left: 1.74625cm;\n    bottom: 0.34625cm;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trusteeReceipt": `TrusteeReceipt__trusteeReceipt____8_0X`,
	"card": `TrusteeReceipt__card___yALmE`,
	"page": `TrusteeReceipt__page___oKoAx`,
	"content": `TrusteeReceipt__content___kQ2lw`,
	"logo": `TrusteeReceipt__logo___U7W4p`,
	"header": `TrusteeReceipt__header___GY8kI`,
	"title": `TrusteeReceipt__title___J3kk2`,
	"textAlignEnd": `TrusteeReceipt__textAlignEnd___pfPta`,
	"signature": `TrusteeReceipt__signature___J6tMK`,
	"fromAddress": `TrusteeReceipt__fromAddress___U1g33`,
	"toAddress": `TrusteeReceipt__toAddress___j6Bk4`
};
export default ___CSS_LOADER_EXPORT___;
